import {
  GET_WITHDRAW_INFO_REQUEST,
  GET_WITHDRAW_INFO_SUCCESS,
  GET_WITHDRAW_INFO_FAILURE
} from 'Store/constants';

const initialState = {
  data: {},
  isLoading: null,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_WITHDRAW_INFO_REQUEST:
      return { ...state, isLoading: true, error: null };
    
    case GET_WITHDRAW_INFO_SUCCESS:
      return { data: action.payload, isLoading: false, error: null };
    
    case GET_WITHDRAW_INFO_FAILURE:
      return { ...initialState, isLoading: false, error: action.payload };
    
    default:
      return state;
  }
};
